import React from "react";
import { Routes, Route, Navigate } from "react-router";

const generateRoutes = (routes) => {
  const routeElements = routes.reduce((acc, curr) => {
    if (curr.children) {
      const list = curr.children.map((child) => {
        const fullPath = curr.path + child.path;
        return (
          <Route
            exact
            key={fullPath}
            path={fullPath}
						element={<child.component />}
          />
        );
      });

      return acc.concat(list);
    } else {
      const fullPath = curr.path;
      return acc.concat(
        <Route
          exact
          key={fullPath}
          path={fullPath}
					element={<curr.component />}
        />
      );
    }
  }, []);
  routeElements.push(
    <Route
      key="page-not-found"
			path="/*"
			element={
				<Navigate
					to="/page-not-found"
					state={{ from: window.location.pathname + window.location.search + window.location.hash }}
					replace
				/>
			}
    />
  );
  return routeElements;
};

export const SwitchRoutes = ({ routes }) => (
  <Routes>{generateRoutes(routes)}</Routes>
);
